import { isMobile as isMobileLib } from 'react-device-detect';

export const isMobile = isMobileLib;
